import { getHeaders, host } from '.';

const parseResponse = (res) => {
  if (!res.ok) throw new Error(res.statusText);
  return res.json();
};

export const fetchAllRoles = async () => {
  const headers = await getHeaders();

  try {
    return fetch(host + `/roles`, { headers, method: 'GET' })
      .then(parseResponse)
      .catch(() => {});
  } catch (e) {}
};
